module.exports = __webpack_public_path__ + "img/个人@3x.49e5cd93.png";